<template>
  <div class="home-banner" :class="bannerClasses">
    <!-- 文字标签区 -->
    <div class="brand-text-bg flex-row">
      <a class="brand-tag paragraph_32" href="/coming-soon" target="_blank" rel="noopener noreferrer">
        品牌影响力<br />指&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数
      </a>
      <a class="brand-tag paragraph_33" href="/specials/brand2022videos/" target="_blank" rel="noopener noreferrer">
        中国品牌<br />强国有我
      </a>
      <a class="brand-tag paragraph_34" href="/brand/cluster.html" target="_blank" rel="noopener noreferrer">
        中国品牌<br />融媒集群
      </a>
      <a class="brand-tag paragraph_35" href="/specials/survey/" target="_blank" rel="noopener noreferrer">
        中&nbsp;&nbsp;&nbsp;国&nbsp;&nbsp;&nbsp;品&nbsp;&nbsp;&nbsp;牌<br />发展现状调研行
      </a>
      <a class="brand-tag paragraph_36" href="#">
        中国品牌<br />会议活动
      </a>
      <a class="brand-tag paragraph_37" href="/brand/brand.html" target="_blank" rel="noopener noreferrer">
        中国品牌<br />研&nbsp;&nbsp;究&nbsp;&nbsp;院
      </a>
      <a class="brand-tag paragraph_38" href="/specials/partner2026/" target="_blank" rel="noopener noreferrer">
        中&nbsp;&nbsp;国&nbsp;&nbsp;品&nbsp;&nbsp;牌<br />战略合作伙伴
      </a>
      <a class="brand-tag paragraph_39" href="/specials/fuyao2026/" target="_blank" rel="noopener noreferrer">
        品牌扶摇计划<br />公&nbsp;&nbsp;益&nbsp;&nbsp;项&nbsp;&nbsp;目
      </a>
    </div>
    <!-- 品牌 logo -->
    <a class="brand-logo flex-col" href="/brand/" target="_blank" rel="noopener noreferrer">
      <img class="image_34" :src="require('../img/FigmaDDSSlicePNG5988a2744ffd93f61e66e570e03a19b6.png')" alt="中国品牌" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    bannerClasses() {
      return {
        'home-banner-fixed': this.fixed,
        'home-banner-fixed-hidden': this.fixed && !this.show
      }
    }
  }
}
</script>

<style scoped>
.home-banner {
  width: 1400px;
  height: 94px;
  margin: 0 auto;
  position: relative;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.home-banner-fixed {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.home-banner-fixed-hidden {
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
  pointer-events: none;
}
.brand-text-bg {
  background-color: rgba(51, 51, 51, 1);
  position: absolute;
  left: 0;
  width: 1400px;
  height: 82px;
}
.brand-logo {
  background-color: rgba(160, 0, 0, 1);
  position: absolute;
  left: -1px;
  top: 0;
  width: 187px;
  height: 94px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image_34 {
  width: 146px;
  height: 44px;
}
.brand-tag {
  display: block;
  height: 49px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: center;
  text-decoration: none;
  line-height: normal;
  margin-top: 14px;
  white-space: nowrap;
  transition: color 0.2s;
}
.brand-tag:hover {
  color: rgba(255, 200, 200, 1);
}
.paragraph_32 {
  width: 90px;
  margin-left: 216px;
}
.paragraph_33 {
  width: 72px;
  margin-left: 43px;
}
.paragraph_34 {
  width: 72px;
  margin-left: 40px;
}
.paragraph_35 {
  width: 126px;
  margin-left: 35px;
}
.paragraph_36 {
  width: 72px;
  margin-left: 42px;
}
.paragraph_37 {
  width: 76px;
  margin-left: 45px;
}
.paragraph_38 {
  width: 110px;
  margin-left: 43px;
}
.paragraph_39 {
  width: 114px;
  margin-left: 39px;
}
.paragraph_40 {
  width: 72px;
  margin: 14px 99px 0 51px;
}
</style>
